/**
 * @generated SignedSource<<1d7ebf31c83bc8248a077ced9a12c1c0>>
 * @relayHash 382838e0d9a03f82d53ca3c4ff84f473
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ff172a02eccf823631baeca802bb406c0f5202def8904b3bb358415fd619d79b

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JswExpandableProjectQuery$variables = {
  cloudId: string;
  entityAri: string;
  noOfBoardsToFetch: number;
  ownerAri: string;
  projectKey: string;
  skipOrderQuery: boolean;
};
export type JswExpandableProjectQuery$data = {
  readonly boardsOrder?: {
    readonly " $fragmentSpreads": FragmentRefs<"JswBoards_navigationCustomisation">;
  } | null;
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly " $fragmentSpreads": FragmentRefs<"JswBoards">;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"SubContainer">;
};
export type JswExpandableProjectQuery = {
  response: JswExpandableProjectQuery$data;
  variables: JswExpandableProjectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noOfBoardsToFetch"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipOrderQuery"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "Variable",
  "name": "entityAri",
  "variableName": "entityAri"
},
v8 = {
  "kind": "Variable",
  "name": "noOfBoardsToFetch",
  "variableName": "noOfBoardsToFetch"
},
v9 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v10 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v11 = [
  (v7/*: any*/),
  (v9/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = {
  "kind": "ScalarField",
  "name": "boardId"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v18 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "noOfBoardsToFetch"
  }
],
v19 = {
  "kind": "LinkedField",
  "name": "defaultNavigationItem",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "JiraNavigationItem",
      "abstractKey": "__isJiraNavigationItem"
    },
    (v17/*: any*/)
  ]
},
v20 = {
  "concreteType": "JiraFavouriteValue",
  "kind": "LinkedField",
  "name": "favouriteValue",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v12/*: any*/)
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v22 = [
  (v12/*: any*/),
  {
    "kind": "ScalarField",
    "name": "subspaceId"
  },
  (v13/*: any*/),
  {
    "kind": "ScalarField",
    "name": "subspaceUrl"
  },
  (v14/*: any*/)
],
v23 = [
  {
    "concreteType": "SubcontainerEdge_CSE",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v16/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/)
            ],
            "type": "JiraBoard"
          },
          {
            "kind": "InlineFragment",
            "selections": (v22/*: any*/),
            "type": "JiraSubspace_CSE"
          },
          (v17/*: any*/)
        ]
      }
    ]
  }
],
v24 = [
  {
    "concreteType": "SettingsMenuItemConnection",
    "kind": "LinkedField",
    "name": "sidebar",
    "plural": false,
    "selections": [
      {
        "concreteType": "SettingsMenuItem",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "menuId"
          },
          {
            "kind": "ScalarField",
            "name": "visible"
          }
        ]
      }
    ]
  },
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JswExpandableProjectQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          },
          {
            "kind": "Variable",
            "name": "skipOrderQuery",
            "variableName": "skipOrderQuery"
          }
        ],
        "kind": "FragmentSpread",
        "name": "SubContainer"
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v10/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      (v8/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "JswBoards"
                  }
                ]
              },
              "action": "THROW"
            }
          ]
        },
        "action": "THROW"
      },
      {
        "condition": "skipOrderQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "boardsOrder",
            "args": (v11/*: any*/),
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "JswBoards_navigationCustomisation"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "JswExpandableProjectQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "kind": "ScalarField",
                "name": "softwareBoardCount"
              },
              {
                "kind": "ScalarField",
                "name": "projectStyle"
              },
              {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              (v13/*: any*/),
              {
                "alias": "canEditProjectConfig",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canPerform"
                  }
                ],
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
              },
              (v14/*: any*/),
              {
                "kind": "LinkedField",
                "name": "mostRecentlyViewedBoard",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v16/*: any*/)
                    ],
                    "type": "JiraBoard"
                  },
                  (v17/*: any*/)
                ]
              },
              {
                "args": (v18/*: any*/),
                "concreteType": "JiraBoardConnection",
                "kind": "LinkedField",
                "name": "boards",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraBoardEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraBoard",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v16/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "boardType"
                          },
                          (v21/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": "subspaces",
                    "concreteType": "JiraSubspaceConnection_CSE",
                    "kind": "LinkedField",
                    "name": "subspaces_cse",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSubspaceEdge_CSE",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraSubspace_CSE",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v22/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "alias": "subcontainersMenu",
                    "concreteType": "JiraSubcontainersSidebarMenu_CSE",
                    "kind": "LinkedField",
                    "name": "subcontainersMenu_cse",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v18/*: any*/),
                        "concreteType": "SubcontainerConnection_CSE",
                        "kind": "LinkedField",
                        "name": "favourites",
                        "plural": false,
                        "selections": (v23/*: any*/)
                      },
                      {
                        "args": (v18/*: any*/),
                        "concreteType": "SubcontainerConnection_CSE",
                        "kind": "LinkedField",
                        "name": "recents",
                        "plural": false,
                        "selections": (v23/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v11/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v24/*: any*/)
      },
      {
        "condition": "skipOrderQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "boardsOrder",
            "args": (v11/*: any*/),
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": (v24/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ff172a02eccf823631baeca802bb406c0f5202def8904b3bb358415fd619d79b",
    "metadata": {},
    "name": "JswExpandableProjectQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8d065c186c9efd7cbdab8b8ad93f7ed4";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
